/**
 * Monitoring / Dashboard 집계 API 에러 → i18n 키만 담은 ErrorMessage
 */

import {
  getBackendI18nKeyFromResponse,
  getHttpStatus,
  getServerMessage,
  isNetworkError,
  looksLikeI18nKey,
  normalizeBackendI18nKey,
} from './apiError';
import type { ErrorMessage } from './types';

const MONITORING_ERRORS = {
  GENERIC: {
    title: 'monitoring:monitoringRequestFailed',
    message: 'monitoring:monitoringRequestFailed',
    type: 'error' as const,
  },
} as const;

export function parseMonitoringApiError(error: unknown): ErrorMessage {
  if (!error) {
    return MONITORING_ERRORS.GENERIC;
  }

  if (isNetworkError(error)) {
    return {
      title: 'auth:network_error',
      message: 'auth:network_error_message',
      type: 'error',
    };
  }

  const fromBackend = getBackendI18nKeyFromResponse(error);
  if (fromBackend && looksLikeI18nKey(fromBackend)) {
    return {
      title: 'monitoring:monitoringRequestFailed',
      message: normalizeBackendI18nKey(fromBackend),
      type: 'error',
    };
  }

  const rawMsg = getServerMessage(error);
  if (rawMsg && looksLikeI18nKey(rawMsg)) {
    return {
      title: 'monitoring:monitoringRequestFailed',
      message: normalizeBackendI18nKey(rawMsg),
      type: 'error',
    };
  }

  switch (getHttpStatus(error)) {
    case 403:
      return {
        title: 'monitoring:monitoringRequestFailed',
        message: 'monitoring:no_monitoring_permission',
        type: 'error',
      };
    case 404:
      return {
        title: 'monitoring:monitoringRequestFailed',
        message: 'monitoring:device_not_found',
        type: 'error',
      };
    case 500:
      return {
        title: 'monitoring:monitoringRequestFailed',
        message: 'monitoring:monitoringRequestFailed',
        type: 'error',
      };
    default:
      return MONITORING_ERRORS.GENERIC;
  }
}
